import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, EffectFade, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Scrollbar]);

$('.tipper_c5f2__slider').each(function(){
  var $element = $(this);
  var $pagination = $(this).find('.swiper-pagination');

  new Swiper($element[0], {
    slidesPerView: 1,
    // If we need pagination
    fadeEffect: { crossFade: true },
    effect: 'fade',
    loop: true,
    pagination: {
      el: $pagination[0],
      clickable: true,
    },
  });
});


$('.tipper_c5f2__tip').on('mouseenter', function(){
  $('.tipper_c5f2__tip').removeClass('active');
  $(this).addClass('active');
});

$('.tipper_c5f2__tip').on('mouseleave', function(){
  $(this).removeClass('active');
});

$('.tipper_c5f2__tipper_list a').on('mouseenter', function(){
  var tip = $(this).attr('data-tip');
  $('.tipper_c5f2__tip').removeClass('active');
  $(tip).addClass('active');
});
